// extracted by mini-css-extract-plugin
module.exports = {"modal":"PopupModal_modal__3x8LJ","modalGrid":"PopupModal_modalGrid__1TMKv","title":"PopupModal_title__17V77"};